import { Box, Chip, Link as MuiLink, Stack, Typography } from '@mui/material'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { ROUTES } from '@/utils/constants'
import { formatDateDMY } from '@/utils/date'
import type { WidgetProps } from './WidgetProps'
import { EmptyHint } from './EmptyHint'

interface ResultRow {
  test_id: number
  lesson_id: number | null
  mode: string | null
  results_score: number | null
  computed_at: string | null
}

export function RecentResultsWidget({ payload }: WidgetProps) {
  const { t } = useTranslation()
  const items = (payload.items ?? []) as ResultRow[]

  if (items.length === 0) {
    return <EmptyHint fallbackKey="dashboard.widgets.recent_results.empty" />
  }

  return (
    <Stack spacing={0.75}>
      {items.map((item) => (
        <Box key={item.test_id} sx={{ display: 'flex', alignItems: 'center', gap: 1, minWidth: 0 }}>
          <MuiLink
            component={Link}
            to={ROUTES.TEST_RUN(item.test_id)}
            variant="body2"
            noWrap
            sx={{ flexGrow: 1, minWidth: 0 }}
          >
            #{item.test_id}
          </MuiLink>
          {item.results_score !== null && (
            <Chip
              size="small"
              color={item.results_score >= 80 ? 'success' : item.results_score >= 50 ? 'default' : 'warning'}
              label={t('dashboard.widgets.recent_results.score', { score: item.results_score })}
            />
          )}
          <Typography variant="caption" color="text.secondary" sx={{ whiteSpace: 'nowrap' }}>
            {formatDateDMY(item.computed_at)}
          </Typography>
        </Box>
      ))}
    </Stack>
  )
}
